var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHvac(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150mm",
    height: "150mm",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "marker21",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker20",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker19",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker15",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "marker14",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Triangle",
    overflow: "visible",
    markerHeight: 1,
    markerWidth: 1,
    orient: "auto-start-reverse",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 1 1"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "m5.77 0-8.65 5v-10z",
    fill: "context-stroke",
    fillRule: "evenodd",
    stroke: "context-stroke",
    strokeWidth: "1pt"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m138.56 110-21.651 12.5v-50l21.651-12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.91 122.5v-50l-64.952-37.5v50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.56 60-21.651 12.5-64.952-37.5 21.651-12.5z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.282,
    cy: 70,
    rx: 11.258,
    ry: 20,
    strokeWidth: 0.99999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m99.593 112.5-8.6603 5 4.3301 2.5 8.6603-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 120-4.3301-2.5v5l4.3301 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.263 125 12.99-7.5-4.3301-2.5-8.6603 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.952 92.5-8.6603 5 4.3301 2.5 8.6602-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.622 100-4.3301-2.5v5l4.3301 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.622 105 12.99-7.5-4.3301-2.5-8.6602 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.933 62.5v10l21.651 12.5v-10z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m92.665 66.5 18.187 10.5",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.665 70.5 18.187 10.5",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#0029ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64.952 57.5s-23.597 1.3764-25.981 15c-2.0109 11.492-30.311 17.5-30.311 17.5",
    markerEnd: "url(#Triangle)",
    markerMid: "url(#Triangle)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.612 82.5s-14.696 16.515-25.981 15c-11.563-1.5527-30.311 17.5-30.311 17.5",
    markerEnd: "url(#marker19)",
    markerMid: "url(#marker15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.424 73.927s-14.696 16.515-25.981 15c-11.563-1.5527-30.311 17.5-30.311 17.5",
    markerEnd: "url(#marker20)",
    markerMid: "url(#marker21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.612 62.5s-19.528 7.0367-25.981 15c-7.3449 9.0644-30.311 17.5-30.311 17.5",
    markerEnd: "url(#Triangle)",
    markerMid: "url(#marker14)"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeDasharray: "1.5, 1.5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.029,
    cy: 70.5,
    rx: 8.9131,
    ry: 15.646
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.029,
    cy: 70.5,
    rx: 5.8848,
    ry: 11.646
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.029,
    cy: 70.5,
    rx: 3.0289,
    ry: 6.354
  }))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.029,
    cy: 70.5,
    rx: 1.4519,
    ry: 2.354,
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/hvac.d881ac48b719dfa9d846f741e3795b4e.svg";
export { ForwardRef as ReactComponent };